export interface CustomFieldValueInterface {
  id?: string;
  label?: string;
  value?: string;
}

export class CustomFieldValue implements CustomFieldValueInterface {
  public id?: string;
  public label?: string;
  public value?: string;

  constructor({
    id = undefined,
    label = undefined,
    value = undefined,
    }: CustomFieldValueInterface) {
    this.id = id;
    this.label = label;
    this.value = value;
  }
}
